module.exports = __webpack_public_path__ + "img/Close_Line-16px-light.b3aa81c7.svg";